import { useLayoutEffect, useRef, useState } from "react";

export function usePageTransition(location) {
  const [displayedLocation, setDisplayedLocation] = useState(location);

  const curKey = `${displayedLocation.pathname}${displayedLocation.search}`;
  const nextKey = `${location.pathname}${location.search}`;

  if (curKey !== nextKey) {
    setDisplayedLocation(location);
  }

  const lastPathname = useRef(location.pathname);

  useLayoutEffect(() => {
    if (lastPathname.current !== location.pathname) {
      lastPathname.current = location.pathname;
      window.scrollTo(0, 0);
    }
  }, [location.pathname]);

  return { displayedLocation };
}
